<template>
<div id="user-slide-out" v-bind:class="{'show': showUserInfo, 'hide': !showUserInfo}">
  <aside class="menu">
    <ul class="menu-list">
      <li class="header" v-on:click="TOGGLE_USER_INFO">
        User Info
      </li>
      <li class="form-item">
        <b-switch v-model="localGMT" class="gmt-switch">
            GMT Timestamps
        </b-switch>
      </li>
      <li
        v-if="organization && organization.hd === 'digitasecurity.com'"
        class="link"
        v-on:click="doCopy">
        Copy ID Token
      </li>
      <li class="link" v-on:click="logout">
        Logout
      </li>
    </ul>
  </aside>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'UserSlideOut',
  data() {
    return {
      localGMT: true,
    };
  },
  computed: {
    ...mapState(['showUserInfo', 'organization']),
    ...mapState('primary', ['organization']),
    ...mapState('auth', ['idToken']),
  },
  methods: {
    ...mapMutations(['TOGGLE_USER_INFO', 'SET_GMT']),
    logout() {
      this.$store.dispatch('auth/logoutUser');
      this.$router.push({ name: 'login' });
      this.TOGGLE_USER_INFO();
    },
    doCopy() {
      this.$copyText(this.idToken);
      this.TOGGLE_USER_INFO();
    },
  },
  watch: {
    localGMT() {
      this.SET_GMT(this.localGMT);
    },
  },
};
</script>

<style lang="scss" scoped>

#user-slide-out {
  position: absolute;
  top: $navbar-height;
  right: 0;
  width: $userinfo-width;
  background-color: $userslideout-background;
  z-index: 1000;
}

#user-slide-out.show {
    position: absolute;
    transition-property: right;
    transition-timing-function: linear, ease-in;
    transition-duration: 0.25s;
    right: 0px;
}

#user-slide-out.hide {
    position: absolute;
    transition-property: right;
    transition-timing-function: linear, ease-in;
    transition-duration: 0.25s;
    right: -$userinfo-width;
}

aside {
  li.header, li.link {
    cursor: pointer;
  }

  li.header {
    padding: .5rem;
    color: $link-color;
  }

  li {
    border-bottom: 1px solid $border-color;
    padding: .75rem;
  }

  li:hover {
    background-color: $border-color;
  }
}
</style>
